import _ from 'lodash'
import {
  CREATE_CONFIGURABLE_OPTION_DETAIL,
  EDIT_CONFIGURABLE_OPTION_DETAIL,
  CREATE_CONFIGURABLE_OPTION,
  EDIT_CONFIGURABLE_OPTION,
  DELETE_CONFIGURABLE_OPTION,
  FETCH_CONFIGURABLE_OPTION,
  FETCH_CONFIGURABLE_OPTIONS
} from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_CONFIGURABLE_OPTIONS:
      return _.mapKeys(action.payload, 'id')
    case FETCH_CONFIGURABLE_OPTION:
      return { ...state, [action.payload.id]: action.payload }
    case CREATE_CONFIGURABLE_OPTION:
      return { ...state, [action.payload.id]: action.payload }
    case EDIT_CONFIGURABLE_OPTION:
      return { ...state, [action.payload.id]: action.payload }
    case DELETE_CONFIGURABLE_OPTION:
      return _.omit(state, action.payload)
    case CREATE_CONFIGURABLE_OPTION_DETAIL:
      return { ...state, ..._.mapKeys(action.payload, 'id') }
    case EDIT_CONFIGURABLE_OPTION_DETAIL:
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], ...action.payload }
      }
      return state

    default:
      return state
  }
}
